import type { CardView } from "../api/types";
import type { CatalogCard } from "../api/client";

// CatalogCard → CardView adapter so the shared Card component
// works for both static catalog displays and live game state.

export function catalogToCardView(card: CatalogCard): CardView {
  const atk = card.attack ?? 0;
  const def = card.life ?? 0;
  return {
    entity_id: 0,
    def_id: card.id,
    name: card.name,
    type: card.type,
    cost: card.cost,
    base_attack: atk,
    base_life: def,
    current_attack: atk,
    current_life: def,
    damage_marked: 0,
    remaining_life: def,
    can_attack: false,
    is_attacking: false,
    has_script: false,
    flavor: card.flavor,
    rules_text: card.rules_text,
    // Default to engine route; admin overrides with an explicit URL.
    image_url: card.image_url !== undefined ? card.image_url : `/card-images/${card.id}`,
    faction: card.faction,
    race: card.race ?? null,
    class: card.class ?? null,
    expansion_set: card.expansion_set,
    rarity: card.rarity,
    summon_only: false,
    seal_counters: 0,
    face_down: false,
    keywords: [],
  };
}
